import type { ReactElement } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import QuotaTag from "app/pages/sales-intelligence/modules/quota/components/QuotaTag";
import { DEFAULT_COMPANY_QUOTA_CREDIT } from "app/pages/sales-intelligence/modules/quota/constants";

type Props = {
    isDataCreditsEnabled: boolean;
    isLocked: boolean;
    isPurchased?: boolean;
    hideDataCreditChips?: boolean;
};

const CompanyQuotaIndicator = ({
    isDataCreditsEnabled,
    isLocked,
    isPurchased = false,
    hideDataCreditChips = false,
}: Props): ReactElement | null => {
    if (isDataCreditsEnabled && !hideDataCreditChips && !isPurchased) {
        return (
            <QuotaTag
                size="sm"
                type={isLocked ? "warning" : "light"}
                title={DEFAULT_COMPANY_QUOTA_CREDIT}
            />
        );
    }

    if (!isDataCreditsEnabled && isLocked) {
        return (
            <SWReactIcons
                iconName="locked2"
                size="sm"
                iconColor={colorsPalettes.carbon[300]}
            />
        );
    }

    return null;
};

export default CompanyQuotaIndicator;
